// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Genres } from '../types/genres'

export const getMoviesGenres = (domain: string, serviceId: string): Promise<ResponseAPI<Genres>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceId}/movie/genres`)
